import loadable from '@loadable/component';

export const NewbuildingBrokerSelfRequestFormWidgetAdapterLoadable = loadable(
  () =>
    import('./NewbuildingBrokerSelfRequestFormWidgetAdapter').catch(
      /* istanbul ignore next */ () => ({ NewbuildingBrokerSelfRequestFormWidgetAdapter: () => null }),
    ),
  {
    resolveComponent: ({ NewbuildingBrokerSelfRequestFormWidgetAdapter }) =>
      NewbuildingBrokerSelfRequestFormWidgetAdapter,
    ssr: false,
  },
);
